<template>
  <div class="trading-rules-setting">
    <!-- 上栏查询 -->
    <query-bar
      :query="query"
      :communicationStList="communicationStList"
      :channelTypeList="channelTypeList"
      :sourceChannelTypeList="sourceChannelTypeList"
      :paymentMark="paymentMark"
      :channelStatus="channelStatus"
      @query="onClickQuery"
    />

    <!-- 数据列表 -->
    <list-data :loading="showLoading" :list-data="listData" />

    <!-- 全局组件分页 -->
    <common-page :page-data="pageData" @change="onChangePage">
      <router-link
        class="button"
        slot="right-aside"
        to="/home/paymentChannel/create"
        >新建支付通道</router-link
      >
    </common-page>
  </div>
</template>

<script>
import queryPage from '@/mixins/queryPage'
import QueryBar from './components/QueryBar'
import ListData from './components/ListData'
export default {
  mixins: [queryPage],
  components: {
    QueryBar,
    ListData
  },

  data() {
    return {
      communicationStList: [
        { value: '', label: '全部' },
        { value: 1, label: 'VPN' },
        { value: 2, label: '普通' }
      ],
      channelTypeList: [
        { value: '', label: '全部' },
        { value: 1, label: '银行' },
        { value: 2, label: '第三方支付公司' }
      ],
      sourceChannelTypeList: [
        { value: '', label: '全部' },
        { value: 1, label: '渠道自有第三方通道' },
        { value: 2, label: '盈众自有通道' }
      ],
      paymentMark: [
        { value: '', label: '全部' },
        { value: 1, label: '微信支付' },
        { value: 2, label: '支付宝支付' },
        { value: 3, label: '银联云闪付' },
        { value: 4, label: '京东支付' },
        { value: 5, label: 'POS支付' }
      ],
      channelStatus: [
        { value: '', label: '全部' },
        { value: 1, label: '正常' },
        { value: 2, label: '不正常' }
      ],
      passagewayNameList: []
    }
  },

  methods: {
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { currentPage, pageSize }
      } = this
      const dispatchEvent = 'T4/paymentChannel/getListData'

      return dispatch(dispatchEvent, {
        ...query,
        currentPage,
        pageSize
      }).then(res => {
        this.listData = res.list

        this.pageData.total = res.total
      })
    }
  }
}
</script>
